'use client';

import { CheckboxField, CheckboxVariant } from '@/components/input';
import { Text } from '@/components/text';

import type { FilteringSchemaType } from './form-schema';
import type { ComponentProps } from 'react';
import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { ANALYTICS_EVENTS } from '@/constants';

type PreferenceOption = {
  id: string;
  label: string;
};

const preferencesOptions: PreferenceOption[] = [
  {
    id: 'solarPanels',
    label: 'I have solar panels',
  },

  {
    id: 'electricVehicle',
    label: 'I have an electric vehicle',
  },
  {
    id: 'carbonNeutral',
    label: 'Only show carbon neutral plans',
  },
];

type PreferenceFieldProps = {
  labelVariant?: ComponentProps<typeof Text>['variant'];
  labelAs?: ComponentProps<typeof Text>['as'];
};

const onPreferenceSelected = (value: string) => {
  switch (value) {
    case 'solarPanels':
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.preferences.solarPanel.select, {})
      break;
    case 'electricVehicle':
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.preferences.electricVehicle.select, {})
      break;
    case 'carbonNeutral':
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.preferences.carbonNeutral.select, {})
      break;
    default:
      break;
  }
}

const onPreferenceDeSelected = (value: string) => {
  switch (value) {
    case 'solarPanels':
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.preferences.solarPanel.deselect, {})
      break;
    case 'electricVehicle':
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.preferences.electricVehicle.deselect, {})
      break;
    case 'carbonNeutral':
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.preferences.carbonNeutral.deselect, {})
      break;
    default:
      break;
  }
}

const PreferenceField = ({
  labelVariant = 'h3',
  labelAs = 'h3',
}: PreferenceFieldProps) => (
  <>
    <Text
      variant={labelVariant}
      as={labelAs}
    >
      Preferences
    </Text>
    <CheckboxField<FilteringSchemaType>
      name="preferences"
      variant={CheckboxVariant.RIGHT}
      options={preferencesOptions}
      defaultValue={['solarPanels', 'electricVehicle']}
      onPreferenceSelected={onPreferenceSelected}
      onPreferenceDeSelected={onPreferenceDeSelected}
    />
  </>
);

export { PreferenceField };
